import React from 'react';
import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/eds-icon';
import './PricingCalculatorPricingPageSection.scss';
import { Typography, ArrowRightIcon, Button } from '@eventbrite/marmalade';

const PricingCalculatorSectionText = () => {
    return (
        <div className="pricing-calculator-section-text">
            <span>{gettext('Not sure which plan is best for you?')}</span>

            <Typography as="p" variant="body-md" color="#1E0A3C">
                {gettext(
                    'Use our calculator to explore the recommended plan for your needs, and discover how Eventbrite can boost your ticket sales.',
                )}
            </Typography>
            <div className="pricing-calculator-pricing-page-button">
                <Button
                    onClick={() => {
                        window.location.href = '/l/pricing-calculator/';
                    }}
                    size="responsive"
                    variant="primary"
                >
                    {gettext('Find your plan')}
                    <ArrowRightIcon size="xsmall" color="#ffff" />
                </Button>
            </div>
        </div>
    );
};

const PricingCalculatorSectionImage = () => {
    return (
        <div className="pricing-calculator-section-image">
            <img
                src="https://images.bzyjr9ji.ext.evbdomains.com/marketing/landingpages/pricing/calculator_image.webp"
                alt={gettext('Preview of the Pricing Plan Calculator')}
            ></img>
        </div>
    );
};

export const PricingCalculatorPricingPage = () => {
    return (
        <div className="pricing-calculator-pricing-page-section">
            <PricingCalculatorSectionText />
            <PricingCalculatorSectionImage />
        </div>
    );
};

export default PricingCalculatorPricingPage;
